import * as libphonenumber from 'libphonenumber-js'
import { Keypair } from 'tokend-js-sdk'
import { validateAddress } from './address_validation'
import { i18n } from '@js/i18n'
import { CRYPTO_CURRENCYS } from '@utils/consts'
import CryptoJS from 'crypto-js'

const rules = [
  {
    name: 'phone_number',
    message: i18n.invalid_phone_number(),
    validate: value => libphonenumber.isValidNumber(libphonenumber.parse(value))
  },
  {
    name: 'strong_password',
    message: i18n.valid_password_az(),
    validate: value => {
      let isValid = true
      isValid = isValid && Boolean(value.match(/([a-z])/g))
      isValid = isValid && Boolean(value.match(/([0-9])/g))
      isValid = isValid && !(value.match(/([ ])/g))
      return isValid
    }
  },
  {
    name: 'account_id',
    message: i18n.valid_account_id(),
    validate: value => Keypair.isValidPublicKey(value)
  },
  {
    name: 'secret_key',
    message: i18n.valid_secret_key(),
    validate: value => Keypair.isValidSecretKey(value)
  },
  {
    name: 'email_or_account_id',
    message: i18n.valid_email_or_id(),
    validate: value => validateEmail(value) || Keypair.isValidPublicKey(value)
  },
  {
    name: 'amount',
    message: i18n.validate_amount_number(),
    validate: value => Number(value) && Number(value) > 0
  },
  {
    name: CRYPTO_CURRENCYS.BTC,
    message: i18n.invalid_wallet_address(),
    validate: value => validateAddress(value)
  },
  {
    name: CRYPTO_CURRENCYS.ETH,
    message: i18n.invalid_wallet_address(),
    validate: value => validateAddress(value)
  },
  {
    name: CRYPTO_CURRENCYS.USDTRC,
    message: i18n.invalid_wallet_address(),
    validate: value => validateTRC(value)
  },
  {
    name: CRYPTO_CURRENCYS.USDTERC,
    message: i18n.invalid_wallet_address(),
    validate: value => valideteBEPERC(value)
  },
  {
    name: CRYPTO_CURRENCYS.USDTBEP,
    message: i18n.invalid_wallet_address(),
    validate: value => valideteBEPERC(value)
  },
  {
    name: 'soft_cap',
    getMessage: (field, [cap]) => `Value should be bigger than soft cap: ${i18n.cc(cap)}`,
    validate: (value, [cap]) => +value >= +cap
  },
  {
    name: 'max_issuance',
    getMessage: (field, [max, code]) => `You cant sell more tokens than you have. Available: ${i18n.c(max)} ${code}`,
    validate: (value, [max]) => +value <= +max
  }
]

/**
 *
 * @param {object} validator - vee-validate validator object to add rules
 */
export function extendValidator (validator) {
  addCustomRulesToValidator(validator)
  return validator
}

/**
 *
 * @param {object} validator - vee-validate validator object to add rules
 */
function addCustomRulesToValidator (validator) {
  rules.forEach(rule => {
    validator.extend(rule.name, {
      getMessage: rule.getMessage || (_ => rule.message),
      validate: rule.validate
    })
  })
  return validator
}

function valideteBEPERC (address) {
  if (address.length !== 42 || !address.startsWith('0x')) {
    return false
  }
  const hexRegex = /^0x[a-fA-F0-9]{40}$/
  if (!hexRegex.test(address)) {
    return false
  }
  const addressWithoutPrefix = address.slice(2).toLowerCase()
  const hash = CryptoJS.SHA3(addressWithoutPrefix, { outputLength: 256 }).toString(CryptoJS.enc.Hex)

  let checksumAddress = '0x'

  for (let i = 0; i < addressWithoutPrefix.length; i++) {
    const char = addressWithoutPrefix[i]
    if (parseInt(hash[i], 16) >= 8) {
      checksumAddress += char.toUpperCase()
    } else {
      checksumAddress += char
    }
  }

  return address === checksumAddress
}

function validateTRC (address) {
  if (address.length !== 34) return false
  if (!address.startsWith('T')) return false
  const base58Regex = /^[1-9A-HJ-NP-Za-km-z]+$/
  if (!base58Regex.test(address)) return false
  return true
}

export function validateEmail (email) {
  const reg = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?')
  return reg.test(email)
}

export function validateAccountId (accountId) {
  return Keypair.isValidPublicKey(accountId)
}



// WEBPACK FOOTER //
// ./src/validator/validator.js